import { Observable } from "rxjs";

import { OrdersRepository, PartnerAppRepository } from "lib/repositories/index";
import st from "lib/utils/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "dashboard/INITIALIZE_VIEW";
export const DESTROY_VIEW = "dashboard/DESTROY_VIEW";
export const FETCH_COUNTERS = "dashboard/FETCH_COUNTERS";
export const FETCH_COUNTERS_START = "dashboard/FETCH_COUNTERS_START";
export const FETCH_COUNTERS_SUCCESS = "dashboard/FETCH_COUNTERS_SUCCESS";
export const FETCH_COUNTERS_FAILURE = "dashboard/FETCH_COUNTERS_FAILURE";
export const FETCH_PENDING_ORDERS = "dashboard/FETCH_PENDING_ORDERS";
export const FETCH_PENDING_ORDERS_START = "dashboard/FETCH_PENDING_ORDERS_START";
export const FETCH_PENDING_ORDERS_SUCCESS = "dashboard/FETCH_PENDING_ORDERS_SUCCESS";
export const FETCH_PENDING_ORDERS_FAILURE = "dashboard/FETCH_PENDING_ORDERS_FAILURE";

export const stateSelector = (state) => state.dashboard;

const countersResource = createResourceInstance({
  FETCH: FETCH_COUNTERS,
  FETCH_START: FETCH_COUNTERS_START,
  FETCH_SUCCESS: FETCH_COUNTERS_SUCCESS,
  FETCH_FAILURE: FETCH_COUNTERS_FAILURE,
  stateSelector,
  stateKey: "counters",
  getModel: () => {
    return PartnerAppRepository.getDashboardCounters();
  },
});

const pendingOrdersResource = createResourceInstance({
  FETCH: FETCH_PENDING_ORDERS,
  FETCH_START: FETCH_PENDING_ORDERS_START,
  FETCH_SUCCESS: FETCH_PENDING_ORDERS_SUCCESS,
  FETCH_FAILURE: FETCH_PENDING_ORDERS_FAILURE,
  stateSelector,
  stateKey: "pendingOrders",
  getModel: () => {
    return OrdersRepository.search({
      limit: 3,
      status: "waiting_for_company_approval",
    });
  },
});

const initialState = {
  counters: countersResource.initialState,
  pendingOrders: pendingOrdersResource.initialState,
};

const reducers = {
  ...countersResource.reducersMap,
  ...pendingOrdersResource.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...countersResource.epics,
  ...pendingOrdersResource.epics,

  (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchCounters()),

  (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchPendingOrders()),
];

export const { fetch: fetchCounters } = countersResource.actions;
export const { fetch: fetchPendingOrders } = pendingOrdersResource.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/dashboard/index.js